import { gql, useMutation } from "@apollo/client";
import styled from "styled-components";

import {
  Mutation,
  MutationUpdateCurrentPackageArgs,
} from "../../__generated__/api-graphql-schema";
import { credentialsManager } from "../../auth";
import CenteredPage from "../../components/CenteredPage";
import WalixHeader from "../../components/WalixHeader";
import ProductList from "./ProductList";
import { Product, ProductId } from "./types";

const MUTATION_UPDATE_OPERATOR = gql`
  mutation updateCurrentPackage($input: UpdateCurrentPackageInput!) {
    updateCurrentPackage(input: $input) {
      ok
      mutationErrors {
        field
        message
      }
    }
  }
`;

const MOCK_DATA: Product[] = [
  {
    id: "operatorone",
    title: "Teléfono Básico",
    description:
      "Reprehenderit esse labore id veniam ut veniam non ex adipisicing amet ullamcro dolor proident. Exercitation veli",
    features: [
      { text: "Gratis", boldText: "4 ELEGIDOS" },
      { text: "Llamadas", boldText: "ILIMITADAS" },
      { text: "Larga distancia", boldText: "20 MIN." },
      { text: "Coste inicial", boldText: "$ 0.00" },
    ],
  },
  {
    id: "operatortwo",
    title: "Plan Family All-in-One",
    description:
      "Reprehenderit esse labore id veniam ut veniam non ex adipisicing amet ullamcro dolor proident. Exercitation veli",
    features: [
      { text: "", boldText: "300 Mb Descarga" },
      { text: "", boldText: "Pack Deportes" },
      { text: "", boldText: "Llamadas ilimitadas" },
      { text: "", boldText: "Tarifa SinLímite" },
      // { text: "", boldText: "Contrato 12 meses" },
    ],
  },
];

const MainSection = styled.main`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
`;

function ProductsPage() {
  const accessToken = credentialsManager.readCredentialsFromLocalStorage();

  const [runMutation, { loading, error }] = useMutation<
    Mutation,
    MutationUpdateCurrentPackageArgs
  >(MUTATION_UPDATE_OPERATOR, {
    context: {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    },
  });

  if (loading) {
    console.log("ProductPage: calling API to mutate operator...");
  }
  if (error) {
    console.error("ProductPage: ERROR calling API to mutate operator...");
  }

  const updateOperator = async (operatorId: ProductId): Promise<boolean> => {
    console.debug(`Updating current package to ${operatorId}`);
    try {
      const variables = {
        input: {
          id: operatorId,
        },
      };
      const response = await runMutation({ variables });
      if (response.data?.updateCurrentPackage?.ok === true) {
        return true;
      }

      const mutationErrors = response.data?.updateCurrentPackage?.mutationErrors;
      if (mutationErrors) {
        console.error(mutationErrors);
      }
    } catch (er) {
      console.error(er);
    }
    return false;
  };

  return (
    <CenteredPage>
      <WalixHeader />
      <MainSection>
        <ProductList products={MOCK_DATA} updateOperator={updateOperator} />
      </MainSection>
    </CenteredPage>
  );
}
export default ProductsPage;
